export default {
  none: '0',
  xs: '2px',
  sm: '6px',
  md: '8px',
  lg: '16px',
  xl: '24px',
  round: '99px'
}
